"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionPayloadFields = void 0;
const core_1 = require("../../../core");
/**
 * Notification Payloads
 */
exports.RegionPayloadFields = {
    channelId: core_1.IdSchema,
    campaignId: core_1.IdSchema,
    campaignName: core_1.NameSchema,
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
    regionCountry: core_1.CountrySchema,
    userId: core_1.IdSchema,
    userName: core_1.NameSchema,
};
